







































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { ListHeader } from "@/components/MyListCard.vue";

const RulesHeader: Header[] = [
  { title: "域名", key: "" },
  { title: "协议", key: "" },
  { title: "path", key: "" },
  { title: "服务", key: "" },
  { title: "端口", key: "" }
];

const infoHeader: ListHeader[] = [
  { title: "路由名称", key: "name" },
  { title: "路由描述", key: "description" },
  { title: "创建人", key: "creator" },
  { title: "创建时间", key: "createTime" },
  { title: "更新时间", key: "updateTime" }
];
export default Vue.extend({
  name: "Overview",
  props: { data: { type: Object } },
  data() {
    return {
      RulesHeader,
      infoHeader
    };
  }
});
